import * as React from 'react';

import DisabledButtonWithReason from '../styleguide/DisabledButtonWithReason';
import MinimumOrderWarning from '../dispensary/MinimumOrderWarning';
import MinimumOrderForCodeWarning from '../dispensary/MinimumOrderForCodeWarning';
import SuggestedLowPriceProducts from '../suggestedProducts/SuggestedLowPriceProducts';

import PropTypes from 'prop-types';

import styles from './OrderButton.module.css';

/**
 * Minimum order warnings and low price item carousel
 */
const MinOrderNotMetWarnings = ({
  discountCode,
  minOrderOrDiscountMinDisplay,
}) => {
  return (
    <>
      <div className={styles.buttonWrap}>
        <DisabledButtonWithReason text="Place Order" reason={
          discountCode
            ? <MinimumOrderForCodeWarning
                  discountCode={discountCode}
                  minOrderDisplay={minOrderOrDiscountMinDisplay} />
            : <MinimumOrderWarning />
        } />
      </div>
      <div className={styles.lowPriceCarouselWrap} >
        <SuggestedLowPriceProducts trackingPrefix="checkout" />
      </div>
    </>
  );
}

MinOrderNotMetWarnings.propTypes = {
  discountCode:  PropTypes.string,
  minOrderOrDiscountMinDisplay: PropTypes.string.isRequired,
};

export default MinOrderNotMetWarnings;
